export const UserStatus = ['PENDING','ACTIVE','INACTIVE']
  